import React from 'react';

export default function Image() {
  return (
    <svg className="display-block" width="42" height="36" viewBox="0 0 42 36">
      <path d="M40.21,1.3A1.91,1.91,0,0,1,41.48,2,2.13,2.13,0,0,1,42,3.42V32.54a2.06,2.06,0,0,1-.53,1.39,2.13,2.13,0,0,1-1.27.74A136.54,136.54,0,0,1,21,36,136.53,136.53,0,0,1,1.79,34.66a2.13,2.13,0,0,1-1.27-.74A2.05,2.05,0,0,1,0,32.54V3.42A2.13,2.13,0,0,1,.52,2,1.91,1.91,0,0,1,1.79,1.3,138.52,138.52,0,0,1,21,0,137.91,137.91,0,0,1,40.21,1.3ZM37,30.21V6A120.55,120.55,0,0,0,21.13,5,127.6,127.6,0,0,0,5,6V30.58L8.71,31l16.88-9.94a2.93,2.93,0,0,1,1.58-.42,3.09,3.09,0,0,1,2.42,1.08ZM18,15a4,4,0,0,1-4,4,4,4,0,0,1-4-4,4,4,0,0,1,4-4,4,4,0,0,1,4,4Z" />
    </svg>
  );
}



// WEBPACK FOOTER //
// ./packages/marvel-ui-card/CardThumbnail/icons/Image.js